// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlignmentSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * AlignmentSetting Component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { map } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';
import ButtonCheck from 'share/components/controls/Izenda.ButtonCheck';

export default class AlignmentSetting extends Component {
  state = { alignmentStyle: this.props.value };

  static propTypes = {
    value: PropTypes.string,
      onChange: PropTypes.func
  };

  static defaultProps = {
    value: 'left'
  };

  componentWillReceiveProps(nextProps: any) {
    this.setState({ alignmentStyle: nextProps.value });
  }

  renderButton = (btnName: string, className: string, title: string, isChecked: boolean) => {
    const props = this.props;
    const onClick = () => {
      this.setState({ alignmentStyle: btnName }, function() {
        props.onChange && props.onChange({ value: btnName });
      });
    };

    return (
      <ButtonCheck
        hasValue={isChecked}
        key={btnName}
        type="button"
        className={className}
        onClick={onClick}
        title={title}
      />
    );
  };

  renderButtons = () => {
    const alignmentStyle = this.state.alignmentStyle;
    const btnConfig = [
      {
        btnName: 'left',
        className: 'icon-align-left align-left',
        title: localizer.getText('COMMON_LABEL_ALIGN_LEFT')
      },
      {
        btnName: 'center',
        className: 'icon-align-center align-right',
        title: localizer.getText('COMMON_LABEL_ALIGN_CENTER')
      },
      {
        btnName: 'right',
        className: 'icon-align-right align-center',
        title: localizer.getText('COMMON_LABEL_ALIGN_RIGHT')
      },
      {
        btnName: 'justify',
        className: 'icon-align-justify align-justify',
        title: localizer.getText('COMMON_LABEL_ALIGN_JUSTIFY')
      }
    ];

    return map(
      value => this.renderButton(value.btnName, value.className, value.title, value.btnName === alignmentStyle),
      btnConfig);
  };

  render() {
    const className = classnames('alignment-setting', this.props.className);
    return <div className={className}>{this.renderButtons()}</div>;
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.AlignmentSetting.jsx